import store from '@/store/index.js'
import i18n from '@/i18n'
import meta from "@/meta"

export const translate = (object, field) => {
  const translation = object.translations[store.getters['device/language']]
  return (translation && translation[field]) ? translation[field] : object[field]
}

export const setLanguage = (language) => {
  document.querySelector("html").setAttribute("lang", language);
  i18n.locale = language
  store.commit('device/SET_LANGUAGE', language);
}

export const availableLanguage = (languageSelected) => {
  if(languageSelected.includes("-"))
    languageSelected = languageSelected.substring(0, languageSelected.indexOf("-"))
  return meta.languages.find(language => language === languageSelected)
}